
import React from 'react';
import PropTypes from 'prop-types';

import {
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink
} from 'reactstrap';

import './styles.css';

import {
    logOut
} from '../../Helpers';


import env from '../../env';

let logo = require('../../assets/logo.png');

const routes = {
    login: `${env.url}/login`,
    incidents: `${env.url}/incidents/form`,
    checklists: `${env.url}/checklists/list`,
    completedChecklists: `${env.url}/checklists/completed`,
    task: `${env.url}/tasks/form`,
    home: `${env.url}/`,
    risks: `${env.url}/risks/list`,
    riskForm: `${env.url}/risks/form`,
    documents: `${env.url}/documents/list`,
};

class ElintNav extends React.Component {

    constructor(props) {

        super(props);

        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.state = {
            collapsed: true,
            location: this.props.location
        };
    }

    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }

    buildLinks(path){

        let links = [];

        if(path !== routes.home){
            links.push({
                title: 'Home',
                url: routes.home
            });

            links.push(
                {
                    title: 'Incidents',
                    url: routes.incidents
                }
            );
            links.push(
                {
                    title: 'Complete Checklist',
                    url: routes.checklists
                }
            );
            links.push(
                {
                    title: 'View Checklists',
                    url: routes.completedChecklists
                }
            );
            links.push(
                {
                    title: 'Tasks',
                    url: routes.task
                }
            );
            links.push(
                {
                    title: 'Complete Risk Assessment',
                    url: routes.riskForm
                }
            );
            links.push(
                {
                    title: 'Risk Assessments',
                    url: routes.risks
                }
            );
            links.push(
                {
                    title: 'Documents',
                    url: routes.documents
                }
            );

        }

        links.push(
            {
                title: 'Log out',
                url : this.logOut
            }
        );

        return links;
    };

    logOut = () => {
        logOut();
        window.location.href = env.url + '/login';
    };

    navigate = (link) => {
        if(typeof link === 'string'){
            if(this.props.history){
                this.props.history.push(link);
            }else {
                console.error('History prop is required on Nav component');
            }
        }else {
            if(typeof link === 'function')
                link();
        }
    };

    render() {

        const path = this.state.location? this.state.location.pathname: '/';
        const links = this.buildLinks(path);

        return (
            <div className='top-nav'>
                <Navbar color="faded" dark>

                    <NavbarBrand href={`${env.url}/`} className="mr-auto">
                        <img className="logo" src={logo} alt={"Elint Logo"}/>
                    </NavbarBrand>

                    <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />

                    <Collapse isOpen={!this.state.collapsed} navbar>
                        <Nav navbar>
                            {
                                links.map((link, index) => (
                                    <NavItem key={index} className={path === link.url? 'active': ''}>
                                        {
                                            <NavLink onClick={() => this.navigate(link.url)}>
                                                {link.title}
                                            </NavLink>
                                        }

                                    </NavItem>
                                ))
                            }
                        </Nav>
                    </Collapse>
                </Navbar>
            </div>
        );
    }
}


ElintNav.propTypes = {
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
};

export default ElintNav;



// WEBPACK FOOTER //
// ./src/components/nav/Nav.js